import { render, staticRenderFns } from "./ArticleNameTrackingTable.vue?vue&type=template&id=d5a4c664&scoped=true"
import script from "./ArticleNameTrackingTable.vue?vue&type=script&lang=js"
export * from "./ArticleNameTrackingTable.vue?vue&type=script&lang=js"
import style0 from "./ArticleNameTrackingTable.vue?vue&type=style&index=0&id=d5a4c664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a4c664",
  null
  
)

export default component.exports